import { render, staticRenderFns } from "./CustomerOwner.vue?vue&type=template&id=87041506&scoped=true"
import script from "./CustomerOwner.vue?vue&type=script&lang=js"
export * from "./CustomerOwner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87041506",
  null
  
)

export default component.exports